import { Breakpoint } from "@mui/material";
import { ReactElement } from "react";
import { BaseDialog } from "src/components/BaseDialog/BaseDialog";

export interface StepConfig {
    title: string;
    subtitle?: string;
    maxWidth: Breakpoint;
    actionsLeft?: ReactElement;
    actions?: ReactElement;
    body: ReactElement;
}

interface StepDialogProps {
    config: StepConfig;
    onClose: () => void;
    titleColor?: string;
}

export const StepDialog = ({ config, onClose, titleColor }: StepDialogProps) => (
    <BaseDialog
        onClose={onClose}
        maxWidth={config.maxWidth}
        title={config.title}
        subtitle={config.subtitle}
        titleColor={titleColor}
        actionsLeft={config.actionsLeft}
        actions={config.actions}
    >
        {config.body}
    </BaseDialog>
);